import { TENANT_CH } from 'shared/consts/tenants'

export const getPriceToPrint = (num: number, tenant?: string) => {
  if (tenant === TENANT_CH) {
    return 'CHF ' + String(num.toFixed(2)).replace('.', ',')
  }
  return String(num.toFixed(2)).replace('.', ',') + ' €'
}
